
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.8 9.6v9.6h9.6V9.6H4.8zM3.6 7.2a1.2 1.2 0 00-1.2 1.2v12a1.2 1.2 0 001.2 1.2h12a1.2 1.2 0 001.2-1.2v-12a1.2 1.2 0 00-1.2-1.2h-12z","fill":"#313131"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.4 4.8V6H6V3.4a1 1 0 011-1H20.6a1 1 0 011 1V17a1 1 0 01-1 1H18v-2.4h1.2V4.8H8.4z","fill":"#313131"}})])
          )
        }
      }
    